import React, { useEffect, useRef, useState } from 'react';
import {
    Box,
    VStack,
    HStack,
    Text,
    Input,
    Textarea,
    Button,
    Image,
    FormControl,
    FormLabel,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    Card,
    CardBody,
    Flex,
    Divider,
    useToast,
    Grid,
    GridItem,
    IconButton,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    AccordionItem,
    AccordionButton,
    AccordionIcon,
    Accordion,
    AccordionPanel,
    useColorModeValue,
    Checkbox,
    InputGroup,
    InputLeftElement,
} from '@chakra-ui/react';
import { EditIcon, ViewIcon, DownloadIcon } from '@chakra-ui/icons';
import axiosClient from '../../axios-client';
import { ImFacebook2 } from "react-icons/im";
import { AiFillInstagram } from "react-icons/ai";
import { FaSquareXTwitter } from 'react-icons/fa6';
import { FaLinkedin, FaTiktok, FaYoutube } from 'react-icons/fa';
import { TfiYoutube } from "react-icons/tfi";
import Preview from './Preview';

const WelcomePageEditor = () => {
    const toast = useToast();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [previewMode, setPreviewMode] = useState(false);
    const bgColor = useColorModeValue("white", 'gray.700')
    const [promo, setPromo] = useState(null);
    const [showPromo, setShowPromo] = useState(false);
    const [content, setContent] = useState(null);
    const [tabIndex, setTabIndex] = useState(0);
    const [currentYear, setCurrentYear] = useState(null);
    const [previewUrls, setPreviewUrls] = useState({});

    const previewRef = useRef();

    // Map tab index to section IDs
    const sectionIds = [
        "hero-section",
        "sections-section",
        "features-section",
        "event-section",
        "footer-section",
    ];

    // Scroll smoothly to the section when tab changes
    const handleTabsChange = (index) => {
        setTabIndex(index);
        const sectionId = sectionIds[index];
        const container = previewRef.current;
        const element = container?.querySelector(`#${sectionId}`);

        if (element && container) {

            const containerTop = container.getBoundingClientRect().top;
            const elementTop = element.getBoundingClientRect().top;

            const relativeOffset = (elementTop - containerTop + container.scrollTop);

            container.scrollTo({
                top: relativeOffset,
                behavior: "smooth",
            });
        }
    };


    useEffect(() => {
        axiosClient.get('homepage-content/')
            .then(res => {
                setContent(res.data.content || {});
                setPromo(res.data.promo || null);
                setShowPromo(res.data.show_promo);
                setCurrentYear(res.data.current_year)

            })
            .catch(err => {
                console.error('Failed to load homepage content', err);
            });
    }, []);

    if (!content) {
        return <div>Loading...</div>; // Or your loader
    }

    const handlePromoChange = (field, value) => {
        setPromo(prev => ({
            ...prev,
            [field]: value
        }));
    };
    const handleContentChange = (section, field, value) => {
        setContent(prev => ({
            ...prev,
            [section]: {
                ...prev[section],
                [field]: value
            }
        }));
    };

    const handleFeatureChange = (index, value) => {
        setContent(prev => ({
            ...prev,
            features: {
                ...prev.features,
                items: prev.features.items.map((item, i) => i === index ? value : item)
            }
        }));
    };

    const handleSave = () => {
        // Here you would typically send the data to your backend
        console.log('Saving content:', content);
        toast({
            title: "Contenu sauvegardé",
            description: "Les modifications ont été enregistrées avec succès.",
            status: "success",
            duration: 3000,
            isClosable: true,
        });
    };
    const handleImageUpload = async (target, section, field) => {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";

        input.onchange = async (e) => {
            const file = e.target.files[0];
            if (file) {
                const fileName = file.name;
                const fileExtension = fileName.split(".").pop().toLowerCase();
                const allowedExtensions = ["png", "jpg", "jpeg"];


                // File name length check
                if (fileName.length > 100) {
                    toast({
                        title: 'Erreur de validation.',
                        description: 'Le nom de media ne doit pas dépasser 100 caractères.',
                        status: 'warning',
                        duration: 4000,
                        isClosable: true,
                        position: "bottom-right",
                        variant: "left-accent"
                    });
                    return;
                }

                // File type check
                if (!allowedExtensions.includes(fileExtension)) {
                    toast({
                        title: "Type de fichier invalide",
                        description: "Veuillez télécharger une image au format PNG, JPG ou JPEG.",
                        status: "warning",
                        duration: 3000,
                        variant: "left-accent",
                        isClosable: true,
                    });
                    return;
                }

                const formData = new FormData();
                formData.append("image", file);

                try {
                    const response = await axiosClient.post("upload-image/", formData);

                    const fullUrl = response.data.image_url;
                    const cleanUrl = fullUrl.split('?')[0];
    
                    const key = `${target}.${section}.${field}`;
    
                    setPreviewUrls(prev => ({
                        ...prev,
                        [key]: fullUrl
                    }));

                    if (target === "content") {
                        setContent((prev) => ({
                            ...prev,
                            [section]: {
                                ...prev[section],
                                [field]: cleanUrl
                            }
                        }));
                    } else if (target === "promo") {
                        setPromo((prev) => ({
                            ...prev,
                            [field]: cleanUrl
                        }));
                    }
                } catch (error) {
                    console.error("Image upload failed:", error);
                    toast({
                        title: 'Erreur',
                        description: "Échec de l'envoi de l'image.",
                        status: 'error',
                        duration: 4000,
                        isClosable: true,
                    });
                }
            }
        };

        input.click();
    };

    const handleSubmit = async () => {
        if (showPromo && (!promo.title || !promo.description || !promo.image || !promo.promoCode || !promo.discount || !promo.discountText)) {
            toast({
                // title: "Erreur",
                description: "Veuillez remplire les données de section évenemment",
                status: "warning",
                duration: 3000,
                isClosable: true,
                position: "bottom-right",
                variant: "left-accent"
            });
            return
        }
        try {
            const response = await axiosClient.put('homepage-content/update/', {
                content: content,
                promo: promo,
                show_promo: showPromo,
            });

            toast({
                // title: "Erreur",
                description: "Contenu mis à jour avec succès !",
                status: "success",
                duration: 3000,
                isClosable: true,
                position: "bottom-right",
                variant: "left-accent"
            });
        } catch (error) {
            console.log(error);

            console.error("Erreur lors de la mise à jour :", error);
            toast({
                // title: "Erreur",
                description: "Erreur lors de la mise à jour du contenu.",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "bottom-right",
                variant: "left-accent"
            });
        }
    };


    return (
        <Box minH="100vh" >
            {/* Header */}
            <Box px={{ base: 3, lg: 6 }} py={5}>
                <Flex justify="space-between" align="center">
                    <Text fontSize="2xl" fontWeight="bold">
                        Éditeur de Page d'Accueil Maya+
                    </Text>
                    <HStack>
                        {/* <Button onClick={() => setPreviewMode(true)} leftIcon={<ViewIcon />} colorScheme="blue">
                            Aperçu
                        </Button> */}
                        <Button onClick={handleSubmit} colorScheme="green" leftIcon={<DownloadIcon />}>
                            Sauvegarder
                        </Button>
                    </HStack>
                </Flex>
            </Box>

            <Grid mt={5} templateColumns={{ base: "1fr", xl: "1fr 1fr" }} gap={0} minH="calc(100vh - 80px)">
                {/* Editor Panel */}
                <GridItem rounded={"xl"} w="100%" bg={bgColor}
                    // borderColor="gray.200" 
                    overflowY="auto">
                    <Box p={{ base: 3, md: 6 }}>
                        <Tabs index={tabIndex} onChange={handleTabsChange} variant='soft-rounded' colorScheme='purple'>
                            <TabList >
                                <Tab>Hero</Tab>
                                <Tab>Sections</Tab>
                                <Tab>Fonctionnalités</Tab>
                                <Tab>Événement</Tab>
                                <Tab>Footer</Tab>
                            </TabList>

                            <TabPanels>
                                {/* Hero Tab */}
                                <TabPanel>
                                    <Divider />
                                    <VStack p={3} spacing={6} align="stretch">
                                        <Text fontSize="lg" fontWeight="semibold">Section Hero</Text>

                                        <FormControl>
                                            <FormLabel>Titre principal</FormLabel>
                                            <Input
                                                value={content.hero.title1}
                                                onChange={(e) => handleContentChange('hero', 'title1', e.target.value)}
                                            />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Mot-clé en surbrillance</FormLabel>
                                            <Input
                                                value={content.hero.title2}
                                                onChange={(e) => handleContentChange('hero', 'title2', e.target.value)}
                                            />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Sous-titre</FormLabel>
                                            <Textarea
                                                value={content.hero.subtitle}
                                                onChange={(e) => handleContentChange('hero', 'subtitle', e.target.value)}
                                                rows={3}
                                            />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Texte du bouton</FormLabel>
                                            <Input
                                                value={content.hero.ctaText}
                                                onChange={(e) => handleContentChange('hero', 'ctaText', e.target.value)}
                                            />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Image de fond</FormLabel>
                                            <HStack>
                                                <Input
                                                    value={content.hero.backgroundImage ? content.hero.backgroundImage.split('/').pop() : ''}
                                                    onChange={(e) => handleContentChange('hero', 'backgroundImage', e.target.value)}
                                                    placeholder="URL de l'image"
                                                />
                                                <Button onClick={() => handleImageUpload("content", 'hero', 'backgroundImage')}>
                                                    Upload 
                                                </Button>
                                            </HStack>
                                            {content.hero.backgroundImage && (
                                                <Flex justify={"center"}>
                                                    <Image
                                                        src={previewUrls["content.hero.backgroundImage"] || content.hero.backgroundImage}
                                                        alt="Background preview"
                                                        maxH="200px"
                                                        mt={2}
                                                        borderRadius="md"
                                                    />
                                                    
                                                </Flex>
                                                

                                            )}
                                        </FormControl>
                                    </VStack>

                                </TabPanel>

                                {/* Sections Tab */}
                                <TabPanel>
                                    <VStack spacing={8} align="stretch">
                                        <Accordion allowMultiple>
                                            {/* Section 1 */}
                                            <AccordionItem >
                                                <h2>
                                                    <AccordionButton my={2}>
                                                        <Box fontWeight="semibold" fontSize="md" as='span' flex='1' textAlign='left'>
                                                            Section 1 - Expérience unique
                                                        </Box>
                                                        <AccordionIcon />
                                                    </AccordionButton>
                                                </h2>
                                                <AccordionPanel px={{ base: 0, lg: 4 }} pb={4}>

                                                    <Card p={0}  >
                                                        <CardBody >
                                                            <VStack spacing={4} align="stretch">
                                                                <FormControl>
                                                                    <FormLabel>Badge</FormLabel>
                                                                    <Input
                                                                        value={content.section1.badge}
                                                                        onChange={(e) => handleContentChange('section1', 'badge', e.target.value)}
                                                                    />
                                                                </FormControl>

                                                                <FormControl>
                                                                    <FormLabel>Titre</FormLabel>
                                                                    <Input
                                                                        value={content.section1.title}
                                                                        onChange={(e) => handleContentChange('section1', 'title', e.target.value)}
                                                                    />
                                                                </FormControl>

                                                                <FormControl>
                                                                    <FormLabel>Description</FormLabel>
                                                                    <Textarea
                                                                        value={content.section1.description}
                                                                        onChange={(e) => handleContentChange('section1', 'description', e.target.value)}
                                                                        rows={4}
                                                                    />
                                                                </FormControl>

                                                                <FormControl>
                                                                    <FormLabel>Image</FormLabel>
                                                                    <HStack>
                                                                        <Input
                                                                            value={content.section1.image ? content.section1.image.split('/').pop() : ''}
                                                                            onChange={(e) => handleContentChange('section1', 'image', e.target.value)}
                                                                        />
                                                                        <Button onClick={() => handleImageUpload("content", 'section1', 'image')}>
                                                                            Upload
                                                                        </Button>
                                                                    </HStack>
                                                                    {content.section1.image && (
                                                                        <Flex justify={"center"}>
                                                                            <Image
                                                                                src={previewUrls["content.section1.image"] || content.section1.image}
                                                                                alt="Section 1 preview"
                                                                                maxH="150px"
                                                                                mt={2}
                                                                                borderRadius="md"
                                                                            />
                                                                        </Flex>

                                                                    )}
                                                                </FormControl>
                                                            </VStack>
                                                        </CardBody>
                                                    </Card>

                                                </AccordionPanel>
                                            </AccordionItem>
                                            {/* Section 2 */}
                                            <AccordionItem>
                                                <h2>
                                                    <AccordionButton my={2}>
                                                        <Box fontWeight="semibold" fontSize="md" as='span' flex='1' textAlign='left'>
                                                            Section 2 - Cinéma familial
                                                        </Box>
                                                        <AccordionIcon />
                                                    </AccordionButton>
                                                </h2>
                                                <AccordionPanel px={{ base: 0, lg: 4 }} pb={4}>

                                                    <Card>
                                                        <CardBody>
                                                            <VStack spacing={4} align="stretch">
                                                                <FormControl>
                                                                    <FormLabel>Titre</FormLabel>
                                                                    <Input
                                                                        value={content.section2.title}
                                                                        onChange={(e) => handleContentChange('section2', 'title', e.target.value)}
                                                                    />
                                                                </FormControl>

                                                                <FormControl>
                                                                    <FormLabel>Description</FormLabel>
                                                                    <Textarea
                                                                        value={content.section2.description}
                                                                        onChange={(e) => handleContentChange('section2', 'description', e.target.value)}
                                                                        rows={4}
                                                                    />
                                                                </FormControl>

                                                                <FormControl>
                                                                    <FormLabel>Image</FormLabel>
                                                                    <HStack>
                                                                        <Input
                                                                            value={content.section2.image ? content.section2.image.split('/').pop() : ''}
                                                                            onChange={(e) => handleContentChange('section2', 'image', e.target.value)}
                                                                        />
                                                                        <Button onClick={() => handleImageUpload("content", 'section2', 'image')}>
                                                                            Upload
                                                                        </Button>
                                                                    </HStack>
                                                                    {content.section2.image && (
                                                                        <Flex justify={"center"}>


                                                                            <Image
                                                                                src={previewUrls["content.section2.image"] || content.section2.image}
                                                                                alt="Section 2 preview"
                                                                                maxH="150px"
                                                                                mt={2}
                                                                                borderRadius="md"
                                                                            />
                                                                        </Flex>
                                                                    )}
                                                                </FormControl>
                                                            </VStack>
                                                        </CardBody>
                                                    </Card>
                                                </AccordionPanel>
                                            </AccordionItem>
                                            {/* Section 3 */}
                                            <AccordionItem>
                                                <h2>
                                                    <AccordionButton my={2}>
                                                        <Box fontWeight="semibold" fontSize="md" as='span' flex='1' textAlign='left'>
                                                            Section 3 - Première image horizontale
                                                        </Box>
                                                        <AccordionIcon />
                                                    </AccordionButton>
                                                </h2>
                                                <AccordionPanel px={{ base: 0, lg: 4 }} pb={4}>

                                                    <Card>
                                                        <CardBody>
                                                            <VStack spacing={4} align="stretch">


                                                                <FormControl>
                                                                    <FormLabel>Image</FormLabel>
                                                                    <HStack>
                                                                        <Input
                                                                            value={content.section3.image ? content.section3.image.split('/').pop() : ''}
                                                                            onChange={(e) => handleContentChange('section3', 'image', e.target.value)}
                                                                        />
                                                                        <Button onClick={() => handleImageUpload("content", 'section3', 'image')}>
                                                                            Upload
                                                                        </Button>
                                                                    </HStack>
                                                                    {content.section3.image && (
                                                                        <Flex justify={"center"}>
                                                                            <Image
                                                                                src={previewUrls["content.section3.image"] || content.section3.image}
                                                                                alt="Section 3 preview"
                                                                                maxH="150px"
                                                                                mt={2}
                                                                                borderRadius="md"
                                                                            /></Flex>
                                                                    )}
                                                                </FormControl>
                                                            </VStack>
                                                        </CardBody>
                                                    </Card>
                                                </AccordionPanel>
                                            </AccordionItem>
                                            {/* Section 4 */}
                                            <AccordionItem>
                                                <h2>
                                                    <AccordionButton my={2}>
                                                        <Box fontWeight="semibold" fontSize="md" as='span' flex='1' textAlign='left'>
                                                            Section 4 - Divertissement intelligent
                                                        </Box>
                                                        <AccordionIcon />
                                                    </AccordionButton>
                                                </h2>
                                                <AccordionPanel px={{ base: 0, lg: 4 }} pb={4}>

                                                    <Card>
                                                        <CardBody>

                                                            <VStack spacing={4} align="stretch">
                                                                <FormControl>
                                                                    <FormLabel>Titre</FormLabel>
                                                                    <Input
                                                                        value={content.section4.title}
                                                                        onChange={(e) => handleContentChange('section4', 'title', e.target.value)}
                                                                    />
                                                                </FormControl>

                                                                <FormControl>
                                                                    <FormLabel>Description</FormLabel>
                                                                    <Textarea
                                                                        value={content.section4.description}
                                                                        onChange={(e) => handleContentChange('section4', 'description', e.target.value)}
                                                                        rows={4}
                                                                    />
                                                                </FormControl>

                                                                <FormControl>
                                                                    <FormLabel>Image</FormLabel>
                                                                    <HStack>
                                                                        <Input
                                                                            value={content.section4.image ? content.section4.image.split('/').pop() : ''}
                                                                            onChange={(e) => handleContentChange('section4', 'image', e.target.value)}
                                                                        />
                                                                        <Button onClick={() => handleImageUpload("content", 'section4', 'image')}>
                                                                            Upload
                                                                        </Button>
                                                                    </HStack>
                                                                    {content.section4.image && (
                                                                        <Flex justify={"center"}>


                                                                            <Image
                                                                                src={previewUrls["content.section4.image"] || content.section4.image}
                                                                                alt="Section 4 preview"
                                                                                maxH="150px"
                                                                                mt={2}
                                                                                borderRadius="md"
                                                                            />
                                                                        </Flex>
                                                                    )}
                                                                </FormControl>
                                                            </VStack>
                                                        </CardBody>
                                                    </Card>
                                                </AccordionPanel>
                                            </AccordionItem>
                                            {/* Section 5 */}
                                            <AccordionItem>
                                                <h2>
                                                    <AccordionButton my={2}>
                                                        <Box fontWeight="semibold" fontSize="md" as='span' flex='1' textAlign='left'>
                                                            Section 5 - Maya+ Originals
                                                        </Box>
                                                        <AccordionIcon />
                                                    </AccordionButton>
                                                </h2>
                                                <AccordionPanel pb={4}>

                                                    <Card>
                                                        <CardBody>
                                                            <VStack spacing={4} align="stretch">
                                                                <FormControl>
                                                                    <FormLabel>Badge</FormLabel>
                                                                    <Input
                                                                        value={content.section5.badge}
                                                                        onChange={(e) => handleContentChange('section5', 'badge', e.target.value)}
                                                                    />
                                                                </FormControl>

                                                                <FormControl>
                                                                    <FormLabel>Titre</FormLabel>
                                                                    <Input
                                                                        value={content.section5.title}
                                                                        onChange={(e) => handleContentChange('section5', 'title', e.target.value)}
                                                                    />
                                                                </FormControl>

                                                                <FormControl>
                                                                    <FormLabel>Description</FormLabel>
                                                                    <Textarea
                                                                        value={content.section5.description}
                                                                        onChange={(e) => handleContentChange('section5', 'description', e.target.value)}
                                                                        rows={4}
                                                                    />
                                                                </FormControl>

                                                                <FormControl>
                                                                    <FormLabel>Image</FormLabel>
                                                                    <HStack>
                                                                        <Input
                                                                            value={content.section5.image ? content.section5.image.split('/').pop() : ''}
                                                                            onChange={(e) => handleContentChange('section5', 'image', e.target.value)}
                                                                        />
                                                                        <Button onClick={() => handleImageUpload("content", 'section5', 'image')}>
                                                                            Upload
                                                                        </Button>
                                                                    </HStack>
                                                                    {content.section5.image && (
                                                                        <Flex justify={"center"}>
                                                                            <Image
                                                                                src={previewUrls["content.section5.image"] || content.section5.image}
                                                                                alt="Section 5 preview"
                                                                                maxH="150px"
                                                                                mt={2}
                                                                                borderRadius="md"
                                                                            />
                                                                        </Flex>

                                                                    )}
                                                                </FormControl>
                                                            </VStack>
                                                        </CardBody>
                                                    </Card>

                                                </AccordionPanel>
                                            </AccordionItem>
                                            {/* Section 6 */}
                                            <AccordionItem>
                                                <h2>
                                                    <AccordionButton my={2}>
                                                        <Box fontWeight="semibold" fontSize="md" as='span' flex='1' textAlign='left'>
                                                            Section 6 - Deuxième image horizontale
                                                        </Box>
                                                        <AccordionIcon />
                                                    </AccordionButton>
                                                </h2>
                                                <AccordionPanel pb={4}>

                                                    <Card>
                                                        <CardBody>
                                                            <VStack spacing={4} align="stretch">


                                                                <FormControl>
                                                                    <FormLabel>Image</FormLabel>
                                                                    <HStack>
                                                                        <Input
                                                                            value={content.section6.image ? content.section6.image.split('/').pop() : ''}
                                                                            onChange={(e) => handleContentChange('section6', 'image', e.target.value)}
                                                                        />
                                                                        <Button onClick={() => handleImageUpload("content", 'section6', 'image')}>
                                                                            Upload
                                                                        </Button>
                                                                    </HStack>
                                                                    {content.section6.image && (
                                                                        <Flex justify={"center"}>
                                                                            <Image
                                                                                src={previewUrls["content.section6.image"] || content.section6.image}
                                                                                alt="Section 6 preview"
                                                                                maxH="150px"
                                                                                mt={2}
                                                                                borderRadius="md"
                                                                            /></Flex>
                                                                    )}
                                                                </FormControl>
                                                            </VStack>
                                                        </CardBody>
                                                    </Card>
                                                </AccordionPanel>
                                            </AccordionItem>
                                        </Accordion>






                                    </VStack>
                                </TabPanel>

                                {/* Features Tab */}
                                <TabPanel>
                                    <Divider />
                                    <VStack p={3} spacing={6} align="stretch">
                                        <Text fontSize="lg" fontWeight="semibold">Section Fonctionnalités</Text>

                                        <FormControl>
                                            <FormLabel>Titre de la section</FormLabel>
                                            <Input
                                                value={content.features.title}
                                                onChange={(e) => handleContentChange('features', 'title', e.target.value)}
                                            />
                                        </FormControl>

                                        <Text fontWeight="medium">Fonctionnalités :</Text>
                                        {content.features.items.map((feature, index) => (
                                            <FormControl key={index}>
                                                <FormLabel>Fonctionnalité {index + 1}</FormLabel>
                                                <Textarea
                                                    value={feature}
                                                    onChange={(e) => handleFeatureChange(index, e.target.value)}
                                                    rows={2}
                                                />
                                            </FormControl>
                                        ))}
                                    </VStack>
                                </TabPanel>

                                {/* Event Tab */}
                                <TabPanel>
                                    <Divider />
                                    <VStack p={3} spacing={6} align="stretch">
                                        <Text fontSize="lg" fontWeight="semibold">Section Promo</Text>
                                        <FormControl display="flex" alignItems="center">
                                            <Checkbox
                                                isChecked={showPromo}
                                                onChange={(e) => setShowPromo(e.target.checked)}
                                                colorScheme="teal"
                                            >
                                                Afficher la section promotionnelle
                                            </Checkbox>
                                        </FormControl>
                                        <FormControl isRequired>
                                            <FormLabel>Titre</FormLabel>
                                            <Input
                                                value={promo?.title || ''}
                                                onChange={(e) => handlePromoChange('title', e.target.value)}
                                            />
                                        </FormControl>

                                        <FormControl isRequired>
                                            <FormLabel>Description</FormLabel>
                                            <Textarea
                                                value={promo?.description || ''}
                                                onChange={(e) => handlePromoChange('description', e.target.value)}
                                                rows={3}
                                            />
                                        </FormControl>

                                        <FormControl isRequired>
                                            <FormLabel>Code Promo</FormLabel>
                                            <Input
                                                value={promo?.promoCode || ''}
                                                onChange={(e) => handlePromoChange('promoCode', e.target.value)}
                                            />
                                        </FormControl>

                                        <FormControl isRequired>
                                            <FormLabel>Réduction</FormLabel>
                                            <Input
                                                type='number'
                                                value={promo?.discount || ''}
                                                onChange={(e) => handlePromoChange('discount', e.target.value)}
                                            />
                                        </FormControl>
                                        <FormControl isRequired>
                                            <FormLabel>Texte de réduction</FormLabel>
                                            <Input
                                                value={promo?.discountText || ''}
                                                onChange={(e) => handlePromoChange('discountText', e.target.value)}
                                            />
                                        </FormControl>

                                        <FormControl isRequired>
                                            <FormLabel>Image</FormLabel>
                                            <HStack>
                                                <Input
                                                    value={promo?.image ? promo.image.split('/').pop() : ''}
                                                    onChange={(e) => handlePromoChange('image', e.target.value)}
                                                    placeholder="URL de l'image"
                                                />
                                                <Button onClick={() => handleImageUpload("promo", null, "image")}>
                                                    Upload
                                                </Button>
                                            </HStack>
                                            {promo?.image && (
                                                <Flex justify={"center"}>
                                                    <Image
                                                        src={previewUrls["promo.image"] || promo.image}
                                                        alt="Promo preview"
                                                        maxH="200px"
                                                        mt={2}
                                                        borderRadius="md"
                                                    />
                                                </Flex>
                                            )}
                                        </FormControl>


                                    </VStack>
                                </TabPanel>

                                {/* Footer Tab */}
                                <TabPanel>
                                    <Divider />
                                    <VStack p={3} spacing={6} align="stretch">
                                        <Text fontSize="lg" fontWeight="semibold">Footer Section</Text>

                                        <FormControl>
                                            <FormLabel>Lien de téléchargement sur Playstore</FormLabel>
                                            <Input
                                                value={content.footer.playstoreLink}
                                                onChange={(e) => handleContentChange('footer', 'playstoreLink', e.target.value)}
                                            />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Lien de téléchargement sur Appstore</FormLabel>
                                            <Input
                                                value={content.footer.appstoreLink}
                                                onChange={(e) => handleContentChange('footer', 'appstoreLink', e.target.value)}
                                            />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Adresse</FormLabel>
                                            <Textarea
                                                value={content.footer.adresse}
                                                onChange={(e) => handleContentChange('footer', 'adresse', e.target.value)}
                                                rows={3}
                                            />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Email</FormLabel>
                                            <Input
                                                value={content.footer.email}
                                                onChange={(e) => handleContentChange('footer', 'email', e.target.value)}
                                            />
                                        </FormControl>

                                        <FormControl>
                                            <FormLabel>Lien facebook</FormLabel>
                                            <InputGroup>
                                                <InputLeftElement pointerEvents='none'>
                                                    <ImFacebook2 color='#3b5998' />
                                                </InputLeftElement>
                                                <Input
                                                    value={content.footer.facebook}
                                                    onChange={(e) => handleContentChange('footer', 'facebook', e.target.value)}
                                                />
                                            </InputGroup>
                                        </FormControl>
                                        <FormControl>
                                            <FormLabel>Lien instagram</FormLabel>
                                            <InputGroup>
                                                <InputLeftElement pointerEvents='none'>
                                                    {/* <AiFillInstagram color='linear-gradient(45deg, #feda75, #fa7e1e, #d62976, #962fbf, #4f5bd5)' /> */}
                                                    <AiFillInstagram size={22} color='#962fbf' />
                                                </InputLeftElement>
                                                <Input
                                                    value={content.footer.instagram}
                                                    onChange={(e) => handleContentChange('footer', 'instagram', e.target.value)}
                                                />
                                            </InputGroup>
                                        </FormControl>
                                        <FormControl>
                                            <FormLabel>Lien twitter</FormLabel>
                                            <InputGroup>
                                                <InputLeftElement pointerEvents='none'>
                                                    <FaSquareXTwitter size={20} color='black' />
                                                </InputLeftElement>
                                                <Input
                                                    value={content.footer.twitter}
                                                    onChange={(e) => handleContentChange('footer', 'twitter', e.target.value)}
                                                />
                                            </InputGroup>
                                        </FormControl>
                                        <FormControl>
                                            <FormLabel>Lien linkedin</FormLabel>
                                            <InputGroup>
                                                <InputLeftElement pointerEvents='none'>
                                                    <FaLinkedin size={20} color='#006192' />
                                                </InputLeftElement>
                                                <Input
                                                    value={content.footer.linkedin}
                                                    onChange={(e) => handleContentChange('footer', 'linkedin', e.target.value)}
                                                />
                                            </InputGroup>
                                        </FormControl>
                                        <FormControl>
                                            <FormLabel>Lien youtube</FormLabel>
                                            <InputGroup>
                                                <InputLeftElement pointerEvents='none'>
                                                    <FaYoutube size={20} color='red' />
                                                </InputLeftElement>
                                                <Input
                                                    value={content.footer.youtube}
                                                    onChange={(e) => handleContentChange('footer', 'youtube', e.target.value)}
                                                />
                                            </InputGroup>
                                        </FormControl>
                                        <FormControl>
                                            <FormLabel>Lien tiktok</FormLabel>
                                            <InputGroup>
                                                <InputLeftElement pointerEvents='none'>
                                                    <FaTiktok size={20} color='black' />
                                                </InputLeftElement>
                                                <Input
                                                    value={content.footer.tiktok}
                                                    onChange={(e) => handleContentChange('footer', 'tiktok', e.target.value)}
                                                />
                                            </InputGroup>
                                        </FormControl>

                                    </VStack>
                                </TabPanel>
                            </TabPanels>
                        </Tabs>
                    </Box>
                </GridItem>

                {/* Preview Panel */}

                <GridItem
                    ref={previewRef}
                    position="sticky"
                    top="80px"
                    bg="gray.100"
                    overflowY="auto"
                    overflowX="hidden"
                    display={{ base: "none", md: "block" }}
                    // h="calc(100vh - 80px)"
                    h="80vh"
                >
                    <Box style={{ zoom: 0.5 }} w="100%">
                        <Preview currentYear={currentYear} content={content} showPromo={showPromo} promo={promo} previewUrls={previewUrls}/>
                    </Box>
                </GridItem>

            </Grid>
        </Box>
    );
};

export default WelcomePageEditor;